import { Component } from '@theme/component';
import { debounce } from '@theme/utilities';
import { buildSearchUrl } from '@theme/search-url';

class SearchPageInputComponent extends Component {
  requiredRefs = ['searchPageInput'];

  connectedCallback() {
    super.connectedCallback();
    const form = this.refs.searchPageInput.form ?? this.closest('form');
    form?.addEventListener('submit', this.#handleSubmit);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const form = this.refs.searchPageInput.form ?? this.closest('form');
    form?.removeEventListener('submit', this.#handleSubmit);
  }

  #doSearch(query) {
    window.location.href = buildSearchUrl(query).toString();
  }

  #handleSubmit = (event) => {
    event.preventDefault();
    const query = this.refs.searchPageInput.value.trim();
    if (!query) return;
    this.#doSearch(query);
  };

  handleKeyDown = debounce((event) => {
    const value = this.refs.searchPageInput.value.trim();
    if (event.key === 'Escape' && value === '') {
      this.#submitEmptySearch();
      return;
    }
    if (event.key === 'Enter' && value !== '') {
      event.preventDefault();
      this.#doSearch(value);
    }
  }, 200);

  #submitEmptySearch() {
    const searchInput = this.refs.searchPageInput;
    searchInput.focus();
    searchInput.value = '';
    if (this.#isEmptyState()) return;

    const url = new URL(Theme.routes.search_url, location.origin);
    url.searchParams.set('q', '');
    url.searchParams.set('type', 'product');
    window.location.href = url.toString();
  }

  #isEmptyState = () => {
    const url = new URL(window.location.href);
    return (url.searchParams.get('q') ?? '').trim() === '';
  };
}

if (!customElements.get('search-page-input-component')) {
  customElements.define('search-page-input-component', SearchPageInputComponent);
}